<div class="floating-input-wrapper"
     #wrapperEl
     [class.is-textarea]="isTextarea"
     [class.focused]="isFocused"
     [class.has-value]="hasValue"
     [class.disabled]="disabled">
  <div class="floating-input-container">
    <!--
      NgxMaskDirective's selector is `textarea[mask], input[mask]` — it attaches
      whenever the `[mask]` BINDING is syntactically present in the template,
      regardless of whether its runtime value is a real mask or just ''. Once
      attached, it drives the native element's `value` through its own
      MaskService (see NgxMaskDirective.ngOnChanges -> _applyMask), which races
      with/overrides our own [value]="value" binding below — for fields with no
      real mask this reliably clobbers a programmatically-set value (e.g. when
      populating the form in edit mode) back to empty. So the mask-related
      bindings are only ever written when there's an actual mask, keeping
      NgxMaskDirective off unmasked fields entirely.
    -->
    <textarea
      *ngIf="isTextarea && mask"
      [appAutoSize]="value"
      class="floating-input"
      [ngClass]="inputClass"
      [id]="id"
      [name]="name"
      [rows]="rows"
      [disabled]="disabled"
      [required]="required"
      [mask]="mask"
      [dropSpecialCharacters]="dropSpecialCharacters"
      [prefix]="prefix"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInput($event)"
      (keypress)="onKeypress($event)"
      (paste)="onPaste($event)"
      (change)="onChange_event($event)"
      (keyup)="onKeyup($event)"
      [placeholder]="placeholder || ' '"
      [value]="value"
    ></textarea>
    <textarea
      *ngIf="isTextarea && !mask"
      [appAutoSize]="value"
      class="floating-input"
      [ngClass]="inputClass"
      [id]="id"
      [name]="name"
      [rows]="rows"
      [disabled]="disabled"
      [required]="required"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInput($event)"
      (keypress)="onKeypress($event)"
      (paste)="onPaste($event)"
      (change)="onChange_event($event)"
      (keyup)="onKeyup($event)"
      [placeholder]="placeholder || ' '"
      [value]="value"
    ></textarea>

    <input
      *ngIf="!isTextarea && mask"
      class="floating-input"
      [ngClass]="inputClass"
      [type]="type"
      [id]="id"
      [name]="name"
      [disabled]="disabled"
      [required]="required"
      [mask]="mask"
      [dropSpecialCharacters]="dropSpecialCharacters"
      [prefix]="prefix"
      [value]="value"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInput($event)"
      (keypress)="onKeypress($event)"
      (paste)="onPaste($event)"
      (change)="onChange_event($event)"
      (keyup)="onKeyup($event)"
      [placeholder]="placeholder || ' '"
    />
    <input
      *ngIf="!isTextarea && !mask"
      class="floating-input"
      [ngClass]="inputClass"
      [type]="type"
      [id]="id"
      [name]="name"
      [disabled]="disabled"
      [required]="required"
      [value]="value"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInput($event)"
      (keypress)="onKeypress($event)"
      (paste)="onPaste($event)"
      (change)="onChange_event($event)"
      (keyup)="onKeyup($event)"
      [placeholder]="placeholder || ' '"
    />

    <label class="floating-label" #labelEl [class.floating]="isFocused || hasValue">
      <img
        src="assets/icons/required-asterisk.svg"
        *ngIf="required"
        [attr.alt]="'alt.requiredField' | translate"
      >
        <!-- <span class="required-asterisk" *ngIf="required"></span> -->
      {{ label }}
      <span class="floating-label__badge" *ngIf="badge">{{ badge }}</span>
    </label>
  </div>
</div>
